import { Component, EventEmitter, Input, model, Output } from '@angular/core';

@Component({
  selector: 'app-tab-bar',
  imports: [],
  templateUrl: './tab-bar.component.html',
  styleUrl: './tab-bar.component.scss'
})
export class TabBarComponent {
  public activeTab = model<string>('');
  @Input() tabOptions: { label: string; value: string }[] = [];
  @Input() size: 'sm' | 'md' = 'md';
  @Output() tabChanged: EventEmitter<string>  = new EventEmitter<string>();

  changeTab(tabValue: string) {
    this.activeTab.set(tabValue);
    this.tabChanged.emit(tabValue);
  }
}
